import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import createFakeEvent from '../../lib/createFakeEvent';
import Icon from '../Icon/Icon';
import Slider from '../Slider/Slider';

let FADE_TIMER = null;

/**
 * `VolumeSlider` is a component for adjusting the volume.
 *
 * The volume will be a value between 0 (muted) and 1 (maximum volume).
 *
 * @property {boolean} autohide If set to `true`, the volume slider will automatically hide when the mouse is not over the
 * component. Defaults to `true`.
 * @property {string} className The class name of this component. Will be appended to "core-volume-slider".
 * @property {function} onChange The callback that will be invoked whenever the user has changed the volume level.
 * @property {number} volume The volume level.
 *
 * @see Slider
 */
export default class VolumeSlider extends PureComponent {

  static displayName = 'VolumeSlider';

  static propTypes = {
    autohide: PropTypes.bool,
    className: PropTypes.string,
    onChange: PropTypes.func,
    volume: PropTypes.number
  };

  static defaultProps = {
    autohide: true,
    className: '',
    volume: 0.8
  };

  state = {
    showSlider: false,
    mute: false,
    hovering: false,
    holding: false
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.onMouseDown);
    document.addEventListener('mouseup', this.onMouseUp);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.onMouseDown);
    document.removeEventListener('mouseup', this.onMouseUp);
  }

  onClick = e => {
    if (this.state.mute) {
      this.setState(
        {
          mute: false
        },
        () => this.emitChange(this.state.previousVolume)
      );
    } else {
      this.setState(
        {
          mute: true,
          previousVolume: this.props.volume
        },
        () => this.emitChange(0)
      );
    }
  };

  onVolumeChange = e => {
    const vol = e.target.value;
    if (vol > 0 && this.state.mute) {
      this.setState({
        mute: false
      });
    }
    this.emitChange(vol);
  };

  onMouseEnter = e => {
    clearTimeout(FADE_TIMER);
    this.setState({
      hovering: true,
      showSlider: true
    });
  };

  onMouseLeave = e => {
    if (this.state.holding) {
      this.setState({
        hovering: false
      });
    } else {
      this.setState(
        {
          hovering: false
        },
        () => {
          FADE_TIMER = setTimeout(() => {
            this.setState({
              showSlider: false
            });
          }, 2000);
        }
      );
    }
  };

  onMouseUp = e => {
    if (this.state.hovering) {
      this.setState({
        holding: false
      });
    } else {
      this.setState(
        {
          holding: false
        },
        () => {
          FADE_TIMER = setTimeout(() => {
            this.setState({
              showSlider: false
            });
          }, 2000);
        }
      );
    }
  };

  onMouseDown = e => {
    if (this.state.hovering) {
      clearTimeout(FADE_TIMER);
      this.setState({
        holding: true
      });
    }
  };

  emitChange = vol => {
    if (this.props.onChange) {
      this.props.onChange(createFakeEvent(vol));
    }
  };

  // toggleSlider = e => {
  //   if (this.state.mouseHold) {
  //     return;
  //   }
  //   this.setState({
  //     showSlider: !this.state.showSlider
  //   });
  // };
  //
  // toggleMouseHold = e => {
  //   if (!this.state.showSlider) {
  //     return;
  //   }
  //   if (e.type === 'mousedown') {
  //     this.setState({ mouseHold: true });
  //   } else if (e.type === 'mouseup') {
  //     this.setState({ mouseHold: false });
  //   }
  //   return;
  // }

  render() {
    const { className, autohide, ...rest } = this.props;
    const volume = this.state.mute ? 0 : this.props.volume;
    let iconName = 'volume-up';
    if (this.props.volume < 0.5) {
      iconName = 'volume-down';
    }
    if (this.state.mute || this.props.volume === 0) {
      iconName = 'volume-off';
    }
    return (
      <div
        className={`core-volume-slider ${className} ${this.state.showSlider ||
          !this.props.autohide
          ? ''
          : 'hidden-slider'}`}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        <Icon name={iconName} onClick={this.onClick} />
        <Slider {...rest} value={volume} onChange={this.onVolumeChange} />
      </div>
    );
  }

}
